export default "__VITE_ASSET__Ck_Y2nH8__"